// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invalid-feedback {
  margin: 0 !important;
  padding: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/app/invoice/dialogs/addendum-upload/addendum-upload.component.less"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,YAAA;AACJ","sourcesContent":[".invalid-feedback{\n    margin: 0 !important;\n    padding: 8px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
